import reportingComponent from './reporting.component';
import liability from './components/liability';
import routePerformance from './components/route_performance';
import onHold from './components/on_hold';

let reportingModule = angular.module('reporting', [
    liability,
    routePerformance,
    onHold
])
.config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
        .state('liability', {
            url: '/liability',
            component: 'liability',
            parent: 'reporting',
            data: {
                requireLogin: true,
                requireACL: 'reporting_liability.view'
            },
            resolve: {
                hasACL: () => ({})
            }
        })
        .state('route_performance', {
            url: '/route-performance',
            component: 'routePerformance',
            parent: 'reporting',
            data: {
                requireLogin: true,
                requireACL: 'reporting_route_performance.view'
            },
            resolve: {
                hasACL: () => ({})
            }
        })
        .state('on_hold', {
            url: '/on-hold',
            component: 'onHold',
            parent: 'reporting',
            data: {
                requireLogin: true,
                requireACL: 'reporting_on_hold.view'
            },
            resolve: {
                hasACL: () => ({})
            }
        })
})
.component('reporting', reportingComponent)
.name;

export default reportingModule;


// WEBPACK FOOTER //
// ./client/app/components/reporting/index.js